module.exports = __webpack_public_path__ + "static/load-report-chart-8125f84156c28442c90ad471333ddbd8.png";